import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors } from 'member-reducer'
import { selectors as membershipsSelector } from 'memberships/reducer'
import { Button } from 'lp-components'
import { autop } from '@wordpress/autop'
import { makePath, PATH } from 'config'

const propTypes = { blogDetails: PropTypes.object }

function FeaturedPostCard({ featuredPost }) {
  return (
    <a href={featuredPost.permalink} className="featured-card">
      <div className="featured-image-wrapper">
        <img
          src={featuredPost.image_url}
          alt={featuredPost.title}
          className="featured-image"
        />
        {featuredPost.is_private && (
          <div className="overlay">
            <>
              <img
                className="lock-icon"
                src="/assets/images/icons/private.svg"
                alt=""
              />
              <p className="overlay-text">Member Only Access</p>
            </>
          </div>
        )}
      </div>
      <div className="featured-details">
        <div className="featured-category">{featuredPost.categories[0]}</div>
        <div className="featured-title">{featuredPost.title}</div>
      </div>
    </a>
  )
}

function BlogContent({ blogDetails }) {
  const { categories, title, image_url, content, featured_posts } = blogDetails

  return (
    <>
      <div className="top-block" />
      <section className="form-block-container blog">
        <div className="banner">
          {categories.map((category) => (
            <span key={category}>{category}</span>
          ))}
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="blog-container">
          <div className="blog-content">
            <img src={image_url} alt="" />
            <div
              className="rich-text"
              dangerouslySetInnerHTML={{ __html: autop(content) }}
            />
            <hr />
            <div className="button-wrapper">
              <Button
                className="button-primary-outline"
                onClick={() =>
                  window.location.replace(makePath(PATH.SEATOW, PATH.BLOG))
                }
              >
                Back to Blog
              </Button>
            </div>
          </div>
          <div className="featured-posts">
            <div className="featured-header">FEATURED POSTS</div>
            {featured_posts.map((post) => (
              <FeaturedPostCard key={post.id} featuredPost={post} />
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

BlogContent.propTypes = propTypes

function mapStateToProps(state) {
  return {
    allMemberships: membershipsSelector.allMemberships(state),
    blogDetails: selectors.blogDetails(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  BlogContent,
)
